const currentEstActionsAction = (payload) => {
    return { type: 'SET_ESTABLISHMENT', payload:payload };
};

export default currentEstActionsAction;